import { Link, useLocation } from "wouter";
import { Home, ClipboardList, CheckSquare, Eye, FileText, ArrowLeft } from "lucide-react";

export default function FounderLayout({ children, founderId, cohortSlug }: { children: React.ReactNode; founderId: number; cohortSlug: string }) {
  const [location] = useLocation();
  const base = `/c/${cohortSlug}/founder/${founderId}`;

  const navItems = [
    { href: base, label: "Home", icon: Home, exact: true },
    { href: `${base}/checkin`, label: "Weekly Check-in", icon: ClipboardList },
    { href: `${base}/approvals`, label: "Approvals", icon: CheckSquare },
    { href: `${base}/preview`, label: "Profile Preview", icon: Eye },
    { href: `${base}/documents`, label: "Data Room", icon: FileText },
  ];

  return (
    <div className="flex min-h-screen w-full bg-background flex-col md:flex-row">
      <aside className="w-full md:w-64 bg-sidebar border-r border-sidebar-border text-sidebar-foreground flex-shrink-0 flex flex-col hidden md:flex">
        <div className="p-6 border-b border-sidebar-border">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-md bg-primary flex items-center justify-center">
              <span className="text-primary-foreground font-bold text-sm">F</span>
            </div>
            <div>
              <h1 className="text-lg font-sans tracking-tight font-bold text-white">Favcy</h1>
              <p className="text-sidebar-foreground/50 text-[10px] font-mono uppercase tracking-[0.2em] leading-none">Founder Workspace</p>
            </div>
          </div>
        </div>
        <nav className="flex-1 p-3 space-y-0.5 overflow-y-auto">
          {navItems.map((item) => {
            const isActive = item.exact
              ? location === item.href
              : location.startsWith(item.href);
            return (
              <Link
                key={item.href}
                href={item.href}
                className={`flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-primary text-primary-foreground"
                    : "text-sidebar-foreground/70 hover:bg-sidebar-accent hover:text-sidebar-foreground"
                }`}
              >
                <item.icon className="w-4 h-4" />
                {item.label}
              </Link>
            );
          })}
        </nav>
        <div className="p-4 border-t border-sidebar-border">
          <Link href={`/c/${cohortSlug}`} className="flex items-center gap-2 text-xs text-sidebar-foreground/40 hover:text-sidebar-foreground/70">
            <ArrowLeft className="w-3 h-3" /> Back to Command Center
          </Link>
        </div>
      </aside>

      <main className="flex-1 flex flex-col min-w-0 max-h-screen overflow-y-auto">
        <div className="flex-1 p-6 md:p-10 max-w-5xl w-full mx-auto">
          {children}
        </div>
      </main>
    </div>
  );
}
